export default __webpack_public_path__ + "static/media/google.9e2f8d46.png";